module.exports = __webpack_public_path__ + "@/assets/img/041-girl-22.77abc9cf.svg";